import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { RecoilRoot } from 'recoil';

import App from './App';
import configureStore from './redux/configureStore';
import { ReduxState } from './redux/reducers/global';

require('dotenv').config();

const state: ReduxState = {
	auth: {},
	profesor: { user: {} },
	estudiante: { user: {} }
};

const store = configureStore(state);

const renderApp = () =>
	render(
		<RecoilRoot>
			<Provider store={store}>
				<App />
			</Provider>
		</RecoilRoot>,
		document.getElementById('root')
	);

if (module.hot) {
	module.hot.accept('./App', () => {
		const NextApp: any = require('./App').default;
		render(NextApp, document.getElementById('root'));
	});
}

renderApp();
